import styled from 'styled-components';
import { spacing, colors, link, fontSizes } from 'ui/theme';

export const StyledListForLinkedWorkflows = styled.ul`
  margin: 0;
  padding-left: 0;
  list-style: none;

  li {
    display: flex;
    padding-left: ${spacing.base};
    position: relative;
    gap: 5px;
  }

  li::before {
    content: '\u2022 ';
    color: ${colors.textPrimary};
    position: absolute;
    left: 0;
    top: 0;
  }

  a {
    ${link}
    font-size: ${fontSizes.s14};
  }

  svg {
    vertical-align: text-top;
    margin-left: ${spacing.quarter};
  }
`;
